/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DamageWaiverTypeFull,
  DamageWaiverTypeFullOptional,
  DamageWaiverTypeFullMetaI,
  DamageWaiverTypeFullTrackedI,
} from "./damage-waiver-type-full";
import {
  DamageWaiverTypeFullTracked,
  DamageWaiverTypeFullMeta,
} from "./damage-waiver-type-full";

/**
 *
 * @export
 * @interface DamageWaiverTypeDTO
 */
export interface DamageWaiverTypeDTOOptional extends DamageWaiverTypeFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof DamageWaiverTypeDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DamageWaiverTypeDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof DamageWaiverTypeDTO
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof DamageWaiverTypeDTO
   */
  displayOrder?: number;
  /**
   * Y/N flag
   * @type {boolean}
   * @memberof DamageWaiverTypeDTO
   */
  active?: boolean;
  /**
   *
   * @type {string}
   * @memberof DamageWaiverTypeDTO
   */
  optionName?: string;
  /**
   *
   * @type {string}
   * @memberof DamageWaiverTypeDTO
   */
  optionDisplayName?: string;
  /**
   *
   * @type {string}
   * @memberof DamageWaiverTypeDTO
   */
  optionDescriptionShort?: string;
  /**
   *
   * @type {string}
   * @memberof DamageWaiverTypeDTO
   */
  optionDescriptionLong?: string;
  /**
   *
   * @type {boolean}
   * @memberof DamageWaiverTypeDTO
   */
  availableOnline?: boolean;
}

export interface DamageWaiverTypeDTO
  extends DamageWaiverTypeDTOOptional, DamageWaiverTypeFull {
  /**
   *
   * @type {boolean}
   * @memberof DamageWaiverTypeDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DamageWaiverTypeDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof DamageWaiverTypeDTO
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof DamageWaiverTypeDTO
   */
  displayOrder?: number;
  /**
   * Y/N flag
   * @type {boolean}
   * @memberof DamageWaiverTypeDTO
   */
  active?: boolean;
  /**
   *
   * @type {string}
   * @memberof DamageWaiverTypeDTO
   */
  optionName?: string;
  /**
   *
   * @type {string}
   * @memberof DamageWaiverTypeDTO
   */
  optionDisplayName?: string;
  /**
   *
   * @type {string}
   * @memberof DamageWaiverTypeDTO
   */
  optionDescriptionShort?: string;
  /**
   *
   * @type {string}
   * @memberof DamageWaiverTypeDTO
   */
  optionDescriptionLong?: string;
  /**
   *
   * @type {boolean}
   * @memberof DamageWaiverTypeDTO
   */
  availableOnline?: boolean;
}

export interface DamageWaiverTypeDTOTrackedI extends DamageWaiverTypeFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof DamageWaiverTypeDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DamageWaiverTypeDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DamageWaiverTypeDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DamageWaiverTypeDTO
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   * Y/N flag
   * @type {boolean}
   * @memberof DamageWaiverTypeDTO
   */
  active?: boolean;
  activeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DamageWaiverTypeDTO
   */
  optionName?: string;
  optionNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DamageWaiverTypeDTO
   */
  optionDisplayName?: string;
  optionDisplayNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DamageWaiverTypeDTO
   */
  optionDescriptionShort?: string;
  optionDescriptionShortIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DamageWaiverTypeDTO
   */
  optionDescriptionLong?: string;
  optionDescriptionLongIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DamageWaiverTypeDTO
   */
  availableOnline?: boolean;
  availableOnlineIsSet: boolean;
}

transformDatesMap.set(
  "DamageWaiverTypeDTO",
  function (model: DamageWaiverTypeDTO) {},
);

export type DamageWaiverTypeDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  optionName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  optionDisplayName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  optionDescriptionShort: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  optionDescriptionLong: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  availableOnline: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var DamageWaiverTypeDTOMeta: DamageWaiverTypeDTOMetaI =
  {} as DamageWaiverTypeDTOMetaI;
DamageWaiverTypeDTOMeta = typeMeta("DamageWaiverTypeDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
  optionName: propertyMeta(
    "optionName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  optionDisplayName: propertyMeta(
    "optionDisplayName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  optionDescriptionShort: propertyMeta(
    "optionDescriptionShort",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  optionDescriptionLong: propertyMeta(
    "optionDescriptionLong",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  availableOnline: propertyMeta(
    "availableOnline",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = DamageWaiverTypeDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DamageWaiverTypeFullMeta]);
  metaI.isDeleted.inheritedFrom = DamageWaiverTypeFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = DamageWaiverTypeFullMeta.isNew;
  metaI.assignId.inheritedFrom = DamageWaiverTypeFullMeta.assignId;
  metaI.displayOrder.inheritedFrom = DamageWaiverTypeFullMeta.displayOrder;
  metaI.active.inheritedFrom = DamageWaiverTypeFullMeta.active;
  metaI.optionName.inheritedFrom = DamageWaiverTypeFullMeta.optionName;
  metaI.optionDisplayName.inheritedFrom =
    DamageWaiverTypeFullMeta.optionDisplayName;
  metaI.optionDescriptionShort.inheritedFrom =
    DamageWaiverTypeFullMeta.optionDescriptionShort;
  metaI.optionDescriptionLong.inheritedFrom =
    DamageWaiverTypeFullMeta.optionDescriptionLong;
  metaI.availableOnline.inheritedFrom =
    DamageWaiverTypeFullMeta.availableOnline;
});

export class DamageWaiverTypeDTOTracked
  extends DamageWaiverTypeFullTracked
  implements DamageWaiverTypeDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  optionName__I?: string = undefined;
  optionNameIsSet: boolean = false;
  set optionName(v: undefined | string) {
    if (v !== undefined) {
      this.optionName__I = v;
      this.optionNameIsSet = true;
    } else {
      this.optionName__I = v || undefined;
      this.optionNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get optionName() {
    return this.optionName__I;
  }
  optionDisplayName__I?: string = undefined;
  optionDisplayNameIsSet: boolean = false;
  set optionDisplayName(v: undefined | string) {
    if (v !== undefined) {
      this.optionDisplayName__I = v;
      this.optionDisplayNameIsSet = true;
    } else {
      this.optionDisplayName__I = v || undefined;
      this.optionDisplayNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get optionDisplayName() {
    return this.optionDisplayName__I;
  }
  optionDescriptionShort__I?: string = undefined;
  optionDescriptionShortIsSet: boolean = false;
  set optionDescriptionShort(v: undefined | string) {
    if (v !== undefined) {
      this.optionDescriptionShort__I = v;
      this.optionDescriptionShortIsSet = true;
    } else {
      this.optionDescriptionShort__I = v || undefined;
      this.optionDescriptionShortIsSet = false;
    }
    this.changeTracker = true;
  }
  get optionDescriptionShort() {
    return this.optionDescriptionShort__I;
  }
  optionDescriptionLong__I?: string = undefined;
  optionDescriptionLongIsSet: boolean = false;
  set optionDescriptionLong(v: undefined | string) {
    if (v !== undefined) {
      this.optionDescriptionLong__I = v;
      this.optionDescriptionLongIsSet = true;
    } else {
      this.optionDescriptionLong__I = v || undefined;
      this.optionDescriptionLongIsSet = false;
    }
    this.changeTracker = true;
  }
  get optionDescriptionLong() {
    return this.optionDescriptionLong__I;
  }
  availableOnline__I?: boolean = undefined;
  availableOnlineIsSet: boolean = false;
  set availableOnline(v: undefined | boolean) {
    if (v !== undefined) {
      this.availableOnline__I = v;
      this.availableOnlineIsSet = true;
    } else {
      this.availableOnline__I = v || undefined;
      this.availableOnlineIsSet = false;
    }
    this.changeTracker = true;
  }
  get availableOnline() {
    return this.availableOnline__I;
  }
  constructor(config?: DamageWaiverTypeDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: DamageWaiverTypeDTOOptional,
    options?: AssignOptions,
  ): DamageWaiverTypeDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (
      config.optionName &&
      this.optionNameApplyFilter(optionsRequired.filter)
    ) {
      this.optionName = config.optionName;
      if (optionsRequired.unassign) this.optionNameIsSet = false;
      else this.optionNameIsSet = true;
    }
    if (
      config.optionDisplayName &&
      this.optionDisplayNameApplyFilter(optionsRequired.filter)
    ) {
      this.optionDisplayName = config.optionDisplayName;
      if (optionsRequired.unassign) this.optionDisplayNameIsSet = false;
      else this.optionDisplayNameIsSet = true;
    }
    if (
      config.optionDescriptionShort &&
      this.optionDescriptionShortApplyFilter(optionsRequired.filter)
    ) {
      this.optionDescriptionShort = config.optionDescriptionShort;
      if (optionsRequired.unassign) this.optionDescriptionShortIsSet = false;
      else this.optionDescriptionShortIsSet = true;
    }
    if (
      config.optionDescriptionLong &&
      this.optionDescriptionLongApplyFilter(optionsRequired.filter)
    ) {
      this.optionDescriptionLong = config.optionDescriptionLong;
      if (optionsRequired.unassign) this.optionDescriptionLongIsSet = false;
      else this.optionDescriptionLongIsSet = true;
    }
    if (
      config.availableOnline &&
      this.availableOnlineApplyFilter(optionsRequired.filter)
    ) {
      this.availableOnline = config.availableOnline;
      if (optionsRequired.unassign) this.availableOnlineIsSet = false;
      else this.availableOnlineIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DamageWaiverTypeDTOTrackedI {
    const cloned = {} as DamageWaiverTypeDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    if (
      this.optionNameIsSetDeep() &&
      this.optionNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optionNameIsSet = true;
      cloned.optionName = this.optionName;
    } else {
      //cloned.optionNameIsSet = false
    }
    if (
      this.optionDisplayNameIsSetDeep() &&
      this.optionDisplayNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optionDisplayNameIsSet = true;
      cloned.optionDisplayName = this.optionDisplayName;
    } else {
      //cloned.optionDisplayNameIsSet = false
    }
    if (
      this.optionDescriptionShortIsSetDeep() &&
      this.optionDescriptionShortApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optionDescriptionShortIsSet = true;
      cloned.optionDescriptionShort = this.optionDescriptionShort;
    } else {
      //cloned.optionDescriptionShortIsSet = false
    }
    if (
      this.optionDescriptionLongIsSetDeep() &&
      this.optionDescriptionLongApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optionDescriptionLongIsSet = true;
      cloned.optionDescriptionLong = this.optionDescriptionLong;
    } else {
      //cloned.optionDescriptionLongIsSet = false
    }
    if (
      this.availableOnlineIsSetDeep() &&
      this.availableOnlineApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.availableOnlineIsSet = true;
      cloned.availableOnline = this.availableOnline;
    } else {
      //cloned.availableOnlineIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DamageWaiverTypeDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    if (!this.optionNameApplyFilter(filter)) this.optionNameIsSet = false;

    if (!this.optionDisplayNameApplyFilter(filter))
      this.optionDisplayNameIsSet = false;

    if (!this.optionDescriptionShortApplyFilter(filter))
      this.optionDescriptionShortIsSet = false;

    if (!this.optionDescriptionLongApplyFilter(filter))
      this.optionDescriptionLongIsSet = false;

    if (!this.availableOnlineApplyFilter(filter))
      this.availableOnlineIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DamageWaiverTypeDTOMeta.isDeleted,
      DamageWaiverTypeDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DamageWaiverTypeDTOMeta.isNew,
      DamageWaiverTypeDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DamageWaiverTypeDTOMeta.assignId,
      DamageWaiverTypeDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DamageWaiverTypeDTOMeta.displayOrder,
      DamageWaiverTypeDTOMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DamageWaiverTypeDTOMeta.active,
      DamageWaiverTypeDTOMeta,
      this.active,
      this,
    );
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  optionNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DamageWaiverTypeDTOMeta.optionName,
      DamageWaiverTypeDTOMeta,
      this.optionName,
      this,
    );
  }
  optionNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.optionNameIsSet && this.optionNameApplyFilter(filter)) return true;

    return false;
  }
  optionDisplayNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DamageWaiverTypeDTOMeta.optionDisplayName,
      DamageWaiverTypeDTOMeta,
      this.optionDisplayName,
      this,
    );
  }
  optionDisplayNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.optionDisplayNameIsSet &&
      this.optionDisplayNameApplyFilter(filter)
    )
      return true;

    return false;
  }
  optionDescriptionShortApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DamageWaiverTypeDTOMeta.optionDescriptionShort,
      DamageWaiverTypeDTOMeta,
      this.optionDescriptionShort,
      this,
    );
  }
  optionDescriptionShortIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.optionDescriptionShortIsSet &&
      this.optionDescriptionShortApplyFilter(filter)
    )
      return true;

    return false;
  }
  optionDescriptionLongApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DamageWaiverTypeDTOMeta.optionDescriptionLong,
      DamageWaiverTypeDTOMeta,
      this.optionDescriptionLong,
      this,
    );
  }
  optionDescriptionLongIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.optionDescriptionLongIsSet &&
      this.optionDescriptionLongApplyFilter(filter)
    )
      return true;

    return false;
  }
  availableOnlineApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DamageWaiverTypeDTOMeta.availableOnline,
      DamageWaiverTypeDTOMeta,
      this.availableOnline,
      this,
    );
  }
  availableOnlineIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.availableOnlineIsSet && this.availableOnlineApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.activeIsSetDeep(filter)) return true;
    if (this.optionNameIsSetDeep(filter)) return true;
    if (this.optionDisplayNameIsSetDeep(filter)) return true;
    if (this.optionDescriptionShortIsSetDeep(filter)) return true;
    if (this.optionDescriptionLongIsSetDeep(filter)) return true;
    if (this.availableOnlineIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
